import { browserHistory } from "react-router";
import { getPreSignedUrl } from "../../utils";
import { getRequest, postRequest } from "../../utils/apiUtils";
import { TOKEN } from "../../utils/constants/localstoregeConstants";
var request = require("request");

export const RECEIVE_GROUP = "RECEIVE_GROUP";
export const RECEIVE_FACILITY = "RECEIVE_FACILITY";
export const RECEIVE_STATUS = "RECEIVE_STATUS";
export const RECEIVE_CHARGES = "RECEIVE_CHARGES";
export const RECEIVE_PREFERANCE = "RECEIVE_PREFERANCE";
export const RECEIVE_REPORTING_TYPE = "RECEIVE_REPORTING_TYPE";
export const RECEIVE_CONTRACT = "RECEIVE_CONTRACT";
export const RECEIVE_CONTRACT_FACILITY = "RECEIVE_CONTRACT_FACILITY";
export const RECEIVE_DEFAULT_FREQ_TYPES = "RECEIVE_DEFAULT_FREQ_TYPES";
export const RECEIVE_LOGIN = "RECEIVE_LOGIN";
export const RECEIVE_ORG_USER = "RECEIVE_ORG_USER";
export const LOGOUT = "LOGOUT";
export const RECEIVE_DEFAULT_STATUS_TYPES = "RECEIVE_DEFAULT_STATUS_TYPES";
export const RECEIVE_REPORT_DATA = "RECEIVE_REPORT_DATA";
export const REPORT_STATUS_TYPES = "REPORT_STATUS_TYPES";
export const PERIODICAL_STATUS_REPORT_DATA = "PERIODICAL_STATUS_REPORT_DATA";
export const REPORT_PDF_DATA = "REPORT_PDF_DATA";

/* Fetch group */

function fetchGroups() {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_groups" })
      .then((response) => {
        //console.log(response.data);
        if (response.data && response.data.result && response.data.result.length > 0) {
          dispatch(requestGroup(response.data.result));
        } else {
          dispatch(requestGroup([]));
        }
      })
      .catch((error) => {
        console.log("fetchGroups error:", error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          browserHistory.push("/");
          window.location.reload();
        }
      });
  };
}

/* fetch facility list based on group */
function fetchFacilityByGroup(id) {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_facilities_group/" + id })
      .then((response) => {
        if (response.data && response.data.result && response.data.result.length > 0) {
          dispatch(requestFacility(response.data.result));
        } else {
          dispatch(requestFacility([]));
        }
      })
      .catch((error) => {
        console.log("fetchFacilityByGroup error:", error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          browserHistory.push("/");
          window.location.reload();
        }
      });
  };
}

/* fetch contract list */

function fetchContract(id) {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_contracts/" + id })
      .then((response) => {
        if (response.data && response.data.result && response.data.result.length > 0) {
          dispatch(requestContract(response.data.result));
        } else {
          dispatch(requestContract([]));
        }
      })
      .catch((error) => {
        console.log("fetchContract error:", error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          browserHistory.push("/");
          window.location.reload();
        }
      });
  };
}

/* fetch faility by contract */
function fetchContractFacility(id) {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_facilities_contract/" + id })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestContractFacility(response.data.result));
        } else {
          dispatch(requestContractFacility([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

/*fetch status */

function fetchStatus() {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_status" })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestStatus(response.data.result));
        } else {
          dispatch(requestStatus([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

/* fetch charge type */

function fetchCharge() {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_charge_type" })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestCharge(response.data.result));
        } else {
          dispatch(requestCharge([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

function fetchPreferance() {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_allocation_preference" })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestPreferance(response.data.result));
        } else {
          dispatch(requestPreferance([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

function fetchReportingType() {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_reporting_type" })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestReportingType(response.data.result));
        } else {
          dispatch(requestReportingType([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

function fetchOrgUser() {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_group_users/3/2" })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestOrgUserList(response.data.result));
        } else {
          dispatch(requestOrgUserList([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

function requestOrgUserList(response) {
  return {
    type: RECEIVE_ORG_USER,
    org_user_list_data: response,
  };
}

function requestGroup(response) {
  return {
    type: RECEIVE_GROUP,
    group_data: response,
  };
}

function requestContract(response) {
  return {
    type: RECEIVE_CONTRACT,
    contract_data: response,
  };
}

function requestContractFacility(response) {
  return {
    type: RECEIVE_CONTRACT_FACILITY,
    contract_facility_data: response,
  };
}

function requestFacility(response) {
  return {
    type: RECEIVE_FACILITY,
    facility_data: response,
  };
}

function requestStatus(response) {
  return {
    type: RECEIVE_STATUS,
    status_data: response,
  };
}

function requestCharge(response) {
  return {
    type: RECEIVE_CHARGES,
    charge_data: response,
  };
}

function requestPreferance(response) {
  return {
    type: RECEIVE_PREFERANCE,
    preferance_data: response,
  };
}

function requestReportingType(response) {
  return {
    type: RECEIVE_REPORTING_TYPE,
    reporting_type_data: response,
  };
}

export function fetchOrgUserList() {
  return (dispatch) => {
    return dispatch(fetchOrgUser());
  };
}

export function fetchGroupList() {
  return (dispatch) => {
    return dispatch(fetchGroups());
  };
}

export function fetchFacilityList(id) {
  return (dispatch) => {
    return dispatch(fetchFacilityByGroup(id));
  };
}

export function fetchContractFacilityList(id) {
  return (dispatch) => {
    return dispatch(fetchContractFacility(id));
  };
}

export function fetchContractList(id) {
  return (dispatch) => {
    return dispatch(fetchContract(id));
  };
}

export function fetchStatusList() {
  return (dispatch) => {
    return dispatch(fetchStatus());
  };
}

export function fetchChargesList() {
  return (dispatch) => {
    return dispatch(fetchCharge());
  };
}

export function fetchPreferanceList() {
  return (dispatch) => {
    return dispatch(fetchPreferance());
  };
}

export function fetchReportingList() {
  return (dispatch, getState) => {
    console.log(getState());
    return dispatch(fetchReportingType());
  };
}

/*fetch default occurenc type  */

function fetchOccrence() {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_occurrence_type" })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestOccurenc(response.data.result));
        } else {
          dispatch(requestOccurenc([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

function requestOccurenc(response) {
  return {
    type: RECEIVE_DEFAULT_FREQ_TYPES,
    occurence_data: response,
  };
}

export function fetchOccurenceList() {
  return (dispatch) => {
    return dispatch(fetchOccrence());
  };
}

/* end */

/*login */

function login(post) {
  return async (dispatch) => {
    try {
      const response = await postRequest({ url: "api/managed_users", payload: post, isLoginURL: true });
      
      if (response.data != "") {
        localStorage.setItem(TOKEN, response.data.result.token_id);
        localStorage.setItem("client_id", response.data.result.client_id);
        
        // Store user data for header component
        localStorage.setItem("user_data", JSON.stringify({
          first_name: response.data.result.first_name,
          last_name: response.data.result.last_name,
          email: response.data.result.email,
          user_id: response.data.result.user_id
        }));
        
        dispatch(requestLogin(response.data));
      } else {
        dispatch(requestLogin([]));
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        browserHistory.push("/");
        window.location.reload();
      }
      dispatch(requestLogin({ success: false, message: error.message || 'Login failed' }));
    }
  };
}

function requestLogin(response) {
  return {
    type: RECEIVE_LOGIN,
    login_user_data: response,
  };
}

export function userLogin(post) {
  return (dispatch) => {
    return dispatch(login(post));
  };
}

/* end */

/* logout */

function logout() {
  return async (dispatch) => {
    return await getRequest({ url: "api/logout" })
      .then((response) => {
        if (response.data != "") {
          dispatch(requestLogout(response.data));
        } else {
          dispatch(requestLogout([]));
        }
      })
      .catch((error) => {
        //throw(error);
        if (error.response) {
          if (error.response.status === 403) {
            //browserHistory.push('/');
            //  window.location.reload();
          } else {
            //console.log(error);
          }
        }
      });
  };
}

function requestLogout(response) {
  return {
    type: LOGOUT,
    logout_data: response,
  };
}

export function userLogout() {
  return (dispatch) => {
    return dispatch(logout());
  };
}

/* end */

/*fetch default occurenc type  */

function fetchOccurenceStatus() {
  return async (dispatch) => {
    return await getRequest({ url: "api/managed_periodical_detail_status" })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestOccurencStatus(response.data.result));
        } else {
          dispatch(requestOccurencStatus([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

function requestOccurencStatus(response) {
  return {
    type: RECEIVE_DEFAULT_STATUS_TYPES,
    occurence_status_data: response,
  };
}

export function fetchOccurenceStatusList() {
  return (dispatch) => {
    return dispatch(fetchOccurenceStatus());
  };
}

/* end */

/* reporting data */

function fetchReportData(post) {
  return async (dispatch) => {
    return await postRequest({ url: "api/get_facility_report_data", payload: post })
      .then((response) => {
        if (response.data.result.length > 0) {
          dispatch(requestReportData(response.data.result));
        } else {
          dispatch(requestReportData([]));
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  };
}

function requestReportData(response) {
  return {
    type: RECEIVE_REPORT_DATA,
    report_response: response,
  };
}

export function fetchXslReportData(post) {
  return (dispatch) => {
    return dispatch(fetchReportData(post));
  };
}

/* end */

// Get Status Data

export function getStatusList() {
  return (dispatch) => {
    return dispatch(getStatusListAction());
  };
}

function getStatusListAction() {
  return async (dispatch) => {
    return await getRequest({ url: `api/get_all_status` }).then((response) => {
      if (response.data.result.length > 0) {
        dispatch(setStatusDataInReducer(response.data.result));
      } else {
        dispatch(setStatusDataInReducer([]));
      }
    });
  };
}

function setStatusDataInReducer(data) {
  return {
    type: REPORT_STATUS_TYPES,
    report_status_types: data,
  };
}

// Get Report PDF

export function getReportPdf(body) {
  return (dispatch) => {
    return dispatch(getReportPdfAction(body));
  };
}

function getReportPdfAction(body) {
  return async (dispatch) => {
    return await postRequest({
      url: `api/periodical_year_report`,
      payload: body,
    }).then((response) => {
      if (response.data.result.report_path) {
        return getPreSignedUrl(response.data.result.report_path);
      } else {
        dispatch(pdfReportData(response.data));
      }
    });
  };
}

function pdfReportData(body) {
  return {
    type: REPORT_PDF_DATA,
    report_pdf_data: body,
  };
}

// Get Periodical Status Report Data

export function getPeriodicalStatusReport(body) {
  return (dispatch) => {
    return dispatch(getPeriodicalStatusReportAction(body));
  };
}

function getPeriodicalStatusReportAction(body) {
  return async (dispatch) => {
    return await postRequest({
      url: `api/periodical_status_report`,
      payload: body,
    }).then((response) => {
      if (response.data.result) {
        return dispatch(setPeriodicalStatusDataInReducer(response.data.result));
      } else {
        dispatch(setPeriodicalStatusDataInReducer({}));
      }
    });
  };
}

function setPeriodicalStatusDataInReducer(data) {
  return {
    type: PERIODICAL_STATUS_REPORT_DATA,
    periodical_status_report_data: data,
  };
}



// WEBPACK FOOTER //
// ./src/shared/actions/actions.js